import {useParams} from 'react-router-dom'
// import { Divider } from 'antd'
// import cardStyles from './AboutCard.variation.module.scss'
// import styles from './RequestForecast.module.scss'
import useStore from 'base/store'
// import {useInputFocus} from 'common/hooks'
import {
  Modal,
  // Text, Block, Button, IconButton, DotsIcon,
  // Form, useForm, useWatch, FormItem, InputAmount,
} from 'common/components'
// import {useGetForecast} from 'common/api'
// import { isEqual } from 'common/helpers'
// import {FIELD_RULES} from 'common/constants'
// import {VariationScheduleList} from '..'
import { VariationForm } from '../../project/components'
import {useGetVariationRequest} from '../api.variation'
// import { SCHEDULE_DATA_FACILITY } from './VariationScheduleList.mock'
// import { 
//   formatMoney,
//   cbFilterSchedule, cbFilterJournal, cbMap2Schedule, cbMap2Journal 
// } from '../schedule.helper'

export default function VariationDataConfirm() {
  const params = useParams()
  const {data:request} = useGetVariationRequest(params.uuid)

  const isModalOpen = useStore((state) => state.isVariationDataConfirmOpen)
  const setModalOpen= useStore((state) => state.setVariationDataConfirmOpen)
  const handleModalClose = () => setModalOpen(false)

  return (
    <>
      <Modal
        title={`Variation Data Confirm`}
        width={1392}
        open={isModalOpen}
        onCancel={handleModalClose}
      >
        <VariationForm project={request?.project} variationRequest={request} onClose={handleModalClose} />
      </Modal>
    </>
  )
}
